/* hc-hero.js - scripts de sections/homepage-hero-original.liquid, externalises le 19-08-2026 (defer). */
(function(){
  var end = new Date('2026-07-20T23:59:59').getTime();
  function pad(n){return n<10?'0'+n:n;}
  function upd(){
    var d = end - Date.now();
    var badge = document.getElementById('heroPromoBadge');
    var span = document.getElementById('heroPromoTime');
    if(d<=0){ if(badge) badge.style.display='none'; return; }
    if(!span) return;
    var days = Math.floor(d/86400000);
    var hrs  = Math.floor((d%86400000)/3600000);
    span.textContent = days>0 ? ('plus que '+days+' j') : (hrs+' h restantes');
  }
  upd(); setInterval(upd, 60000);
})();

// ── HERO SLIDESHOW ──
(function(){
  var slides = document.querySelectorAll('.hero-slide');
  var dots = document.querySelectorAll('.hero-dot');
  var bar = document.getElementById('heroProgressBar');
  if (!slides.length || !dots.length || !bar) return;

  var current = 0;
  var total = slides.length;
  var duration = 5000;
  var timer;

  function resetBar() {
    bar.style.transition = 'none';
    bar.style.width = '0%';
    setTimeout(function(){
      bar.style.transition = 'width ' + duration + 'ms linear';
      bar.style.width = '100%';
    }, 20);
  }

  function goTo(n) {
    slides[current].classList.remove('active');
    dots[current].classList.remove('active');
    current = (n + total) % total;
    slides[current].classList.add('active');
    dots[current].classList.add('active');
    resetBar();
  }

  function start() {
    clearInterval(timer);
    if (total < 2) {
      resetBar();
      return;
    }
    timer = setInterval(function(){ goTo(current + 1); }, duration);
    resetBar();
  }

  dots.forEach(function(dot) {
    dot.addEventListener('click', function(){
      goTo(parseInt(this.getAttribute('data-slide'), 10) || 0);
      start();
    });
  });
  document.addEventListener('visibilitychange', function(){
    if (document.hidden) {
      clearInterval(timer);
    } else {
      start();
    }
  });
  start();
})();